var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isPublicKeyEnabled
    ? _c(
        "div",
        { staticClass: "emd-panel__section" },
        [
          _c(
            "div",
            { staticClass: "eu-display_flex eu-column emd-panel__block" },
            [
              _c("emd-text", { attrs: { tag: "h2", size: "section" } }, [
                _vm._v(" " + _vm._s(_vm.$t("keys.public-key")) + " "),
              ]),
              _c(
                "emd-text",
                {
                  staticClass: "emd-text _color_nonessential eu-py_2",
                  attrs: { size: "tiny" },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("keys.public-key-description")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("copy-clipboard", {
            staticClass: "emd-panel__block eu-basis_4_md eu-basis_2_lg",
            attrs: { copiable: _vm.publicKey },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }